/**
 * Prepares the support page's how-to video lists for keyed rendering. Every Bioflux and Biotres entry is copied with an added urlId built from its url and index, and the two lists are grouped under bioflux and biotres.
 *
 * @param howtoVideos - Bioflux how-to video entries.
 * @param howToVideosBiotres - Biotres how-to video entries.
 * @returns Both video lists with per-entry urlId keys.
 */
const formatHowToVideos = (howtoVideos: any, howToVideosBiotres: any) => ({
  bioflux: howtoVideos?.map((x: any, index: any) => ({
    ...x,
    urlId: `${x.url}-${index}`,
  })),
  biotres: howToVideosBiotres?.map((x: any, index: any) => ({
    ...x,
    urlId: `${x.url}-${index}`,
  })),
});

export { formatHowToVideos };
